export function Spinner({ label }: { label?: string }) {
  return (
    <div className="center-screen stack" style={{ alignItems: "center" }}>
      <div className="spinner" role="status" aria-label={label ?? "Chargement"} />
      {label && <p>{label}</p>}
    </div>
  );
}
